// Floating entry point for the in-app AI assistant: a Fab that is available on
// every screen (mounted in MainLayout, like the other floating widgets) and
// opens the assistant drawer without leaving the current page.
import { lazy, Suspense, useState } from 'react';
import Box from '@mui/material/Box';
import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';
import { useTheme } from '@mui/material/styles';
import { IconSparkles } from '@tabler/icons-react';
import useFunnerInternalAccess from 'hooks/useFunnerInternalAccess';
import { assistantFabDockSx, assistantFabSx } from './assistantPanelSkin';

const AssistantDrawer = lazy(() => import('./AssistantDrawer'));

export default function AssistantWidget() {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const { isAllowed: isFunnerInternal } = useFunnerInternalAccess();

  if (import.meta.env.VITE_ASSISTANT_ENABLED === 'false') return null;
  if (!isFunnerInternal) return null;

  return (
    <>
      {!open && (
        // The dock carries the pulsing halo — a Fab clips its own overflow.
        <Box sx={assistantFabDockSx(theme)}>
          <Tooltip title="עוזר Funner" placement="left">
            <Fab color="primary" size="medium" onClick={() => setOpen(true)} aria-label="פתיחת עוזר AI" sx={assistantFabSx(theme)}>
              <IconSparkles size={23} stroke={1.7} />
            </Fab>
          </Tooltip>
        </Box>
      )}
      <Suspense fallback={null}>{open && <AssistantDrawer open={open} onClose={() => setOpen(false)} />}</Suspense>
    </>
  );
}
